@if (ready) {
  <div class="persona-picker-container">
    <div class="persona-picker-header">
      <div class="persona-picker-welcome">Welcome Back, {{ selfPersona.first_name }}!</div>
      @if (header) {
        <h2 class="persona-picker-title">{{ header }}</h2>
      }
    </div>
    <se-po-persona-picker #picker
      (pick)="onPick($event)"
      (edit)="onEdit($event)"
      (action)="onAction($event)"
      (editMissingInfo)="onEditMissingInfo($event)"
      [profiles]="managedProfiles"
      [profilesFrames]="userProfilesFrames"
    ></se-po-persona-picker>
    @if (!excludeManagedProfiles && permissions.selfIsAdult) {
      <div class="add-profile-btn">
        <se-fe-chip
          seFeDataText="Add new child"
          seFeDataIconLeft="plus_circle_outline"
          seFeDataStyle="primary"
          (seFeClick)="onAddProfileClick($event)"
        ></se-fe-chip>
      </div>
    }
  </div>
} @else {
  <se-fe-spinner seFeDataSize="content" [seFeDataCenter]="true"></se-fe-spinner>
}
<se-po-add-profile-modal #addProfileModal
  [selfPersona]="selfPersona"
  [userId]="userId"
  (addedProfile)="onAddProfile($event)"
  (modalClosed)="onAddProfileClose()">
</se-po-add-profile-modal>

<se-po-edit-persona-modal #editPersonaModal
  [showContactInfo]="editInfoProfile?.relationship === 'self'"
  [requiredFields]="['gender']"
  (personaEdited)="onPersonaSave()">
</se-po-edit-persona-modal>
<se-po-add-guardian-modal #addGuardianModal
  (modalClosed)="onAddGuardianClose($event)">
</se-po-add-guardian-modal>
<se-fe-toast></se-fe-toast>
